export const hazardTypes = [
  {
    label: 'Safety',
    value: 'safety_hazards',
  },
  {
    label: 'Biological',
    value: 'biological_hazards',
  },
  {
    label: 'Physical',
    value: 'physical_hazards',
  },
  {
    label: 'Ergonomic',
    value: 'ergonomic_hazards',
  },
  {
    label: 'Chemical',
    value: 'chemical_hazards',
  },
  {
    label: 'Work organization',
    value: 'work_organization_hazards',
  },
  {
    label: 'Environmental',
    value: 'environmental_hazards',
  },
  {
    label: 'Other',
    value: 'other',
  }
];

export const safetyActivityHazardCategories = [
  {
    label: 'Field Operations (Farming)',
    value: 'field_operations_farming',
    hazards: [
      {
        value: 'field_operations__machinery_entanglement',
        label: 'Machinery entanglement (e.g. harvesters, tractors, slashing equipment)',
      },
      {
        value: 'field_operations__vehicle_collisions_or_rollovers',
        label: 'Vehicle collisions or rollovers (including quad bikes and utes)',
      },
      {
        value: 'field_operations__chemical_exposure',
        label: 'Chemical exposure (fertilisers, herbicides, pesticides)',
      },
      {
        value: 'field_operations__dust_inhalation',
        label: 'Dust inhalation (especially during harvest and soil preparation)',
      },
      {
        value: 'field_operations__heat_stress',
        label: 'Heat stress and dehydration',
      },
      {
        value: 'field_operations__manual_handling_injuries',
        label: 'Manual handling injuries (lifting irrigation lines, bags, etc.)',
      },
      {
        value: 'field_operations__slips_trips_falls',
        label: 'Slips, trips, and falls (uneven ground, wet surfaces)',
      },
      {
        value: 'field_operations__noise_exposure',
        label: 'Noise exposure (from machinery and equipment)',
      },
      {
        value: 'field_operations__bee_stings',
        label: 'Bee stings (during pollination)',
      },
      {
        value: 'field_operations__electrical_hazards',
        label: 'Electrical hazards (overhead lines, faulty equipment)',
      },
      {
        value: 'field_operations__fire_risk',
        label: 'Fire risk (dry vegetation, fuel storage)',
      },
      {
        value: 'field_operations__wildlife_encounters',
        label: 'Wildlife encounters (snakes, kangaroos, feral animals)',
      },
    ],
  },
  {
    label: 'Irrigation and Water Management',
    value: 'irrigation_water_management',
    hazards: [
      {
        value: 'irrigation__drowning_risk',
        label: 'Drowning risk (channels, dams, tanks)',
      },
      {
        value: 'irrigation__waterborne_pathogens',
        label: 'Waterborne pathogens (stagnant water, algae)',
      },
      {
        value: 'irrigation__pump_pipe_failure',
        label: 'Pump and pipe failure (pressure hazards, leaks)',
      },
      {
        value: 'irrigation__slippery_surfaces',
        label: 'Slippery surfaces near water infrastructure',
      },
    ],
  },
  {
    label: 'Processing',
    value: 'processing_operations',
    hazards: [
      {
        value: 'processing__moving_parts',
        label: 'Moving parts and pinch points (conveyors, sorters, hulling machines)',
      },
      {
        value: 'processing__dust_explosions',
        label: 'Dust explosions (almond hull and shell dust accumulation)',
      },
      {
        value: 'processing__confined_space_entry',
        label: 'Confined space entry (bins, silos, tanks)',
      },
      {
        value: 'processing__forklift_vehicle_movement',
        label: 'Forklift and vehicle movement (pedestrian interaction)',
      },
      {
        value: 'processing__noise_exposure',
        label: 'Noise exposure (dryers, blowers, mechanical sorters)',
      },
      {
        value: 'processing__chemical_handling',
        label: 'Chemical handling (cleaning agents, fumigants)',
      },
      {
        value: 'processing__ergonomic_strain',
        label: 'Ergonomic strain (repetitive tasks, poor workstation setup)',
      },
      {
        value: 'processing__electrical_faults',
        label: 'Electrical faults (equipment, switchboards)',
      },
      {
        value: 'processing__fire_risk',
        label: 'Fire risk (dry product, machinery overheating)',
      },
    ],
  },
  {
    label: 'Storage and Logistics',
    value: 'storage_logistics',
    hazards: [
      {
        value: 'storage__stacking_racking_hazards',
        label: 'Stacking and racking hazards (falling product or pallets)',
      },
      {
        value: 'storage__load_shifting',
        label: 'Load shifting during transport',
      },
      {
        value: 'storage__temperature_extremes',
        label: 'Temperature extremes in storage areas',
      },
      {
        value: 'storage__pest_infestation',
        label: 'Pest infestation (rodents, insects)',
      },
    ],
  },
  {
    label: 'General',
    value: 'general',
    hazards: [
      {
        value: 'general__poor_lighting',
        label: 'Poor lighting or visibility',
      },
      {
        value: 'general__inadequate_signage',
        label: 'Inadequate signage or traffic control',
      },
      {
        value: 'general__fatigue',
        label: 'Fatigue and long working hours',
      },
      {
        value: 'general__inadequate_ppe',
        label: 'Inadequate PPE use or availability',
      },
      {
        value: 'general__contractor_visitor_unfamiliarity',
        label: 'Contractor or visitor unfamiliarity with site rules',
      },
    ],
  },
  {
    label: 'Other',
    value: 'other',
    hazards: [
      {
        value: 'other',
        label: 'Other (please specify)',
      },
    ],
  },
  {
    // Biosecurity events raised from the Biosecurity Report form (and creatable by
    // hand). The hazards mirror that form's "What are you reporting?" options, so a
    // submitted report maps straight onto a hazard type.
    // Mirrors Hazard::BIOSECURITY_HAZARD_TYPES (PHP) — keep in sync.
    label: 'Biosecurity',
    value: 'biosecurity_hazards',
    hazards: [
      {
        value: 'biosecurity__sick_injured_dead_animals',
        label: 'Sick, injured or dead animals, including wildlife and aquatic animals',
      },
      {
        value: 'biosecurity__plant_pest_disease',
        label: 'Plant, crop or tree pest/disease',
      },
      {
        value: 'biosecurity__bee_ant_pest_disease',
        label: 'Bee or ant pest/disease',
      },
      {
        value: 'biosecurity__weed_invasive_plant',
        label: 'Weed or invasive plant',
      },
      {
        value: 'biosecurity__invasive_land_animal',
        label: 'Invasive or unusual land animal',
      },
      {
        value: 'biosecurity__invasive_marine_organism',
        label: 'Invasive marine organism',
      },
      {
        value: 'biosecurity__imported_goods',
        label: 'Imported goods, parcel, container or cargo',
      },
      {
        value: 'biosecurity__suspected_breach',
        label: 'Suspected biosecurity-law breach',
      },
      {
        value: 'biosecurity__other_unsure',
        label: 'Other or unsure',
      },
    ],
  },
];

const safetyActivityHazardCategoryMap = new Map(
  safetyActivityHazardCategories.map((category) => [category.value, category])
);

const safetyActivityHazardMapEntries = safetyActivityHazardCategories.reduce((entries, category) => {
  category.hazards.forEach((hazard) => {
    entries.push([hazard.value, { ...hazard, category: category.value }]);
  });
  return entries;
}, []);

hazardTypes.forEach((legacyType) => {
  safetyActivityHazardMapEntries.push([
    legacyType.value,
    {
      value: legacyType.value,
      label: legacyType.label,
      category: null,
    },
  ]);
});

const safetyActivityHazardMap = new Map(safetyActivityHazardMapEntries);

export const getSafetyActivityHazardsForCategory = (categoryValue) => {
  if (!categoryValue) {
    return [];
  }
  return safetyActivityHazardCategoryMap.get(categoryValue)?.hazards ?? [];
};

export const getSafetyActivityHazardCategoryLabel = (categoryValue) => {
  return safetyActivityHazardCategoryMap.get(categoryValue)?.label ?? categoryValue;
};

export const getSafetyActivityHazardLabel = (hazardValue) => {
  return safetyActivityHazardMap.get(hazardValue)?.label ?? hazardValue;
};

export const getSafetyActivityHazardCategoryByHazard = (hazardValue) => {
  return safetyActivityHazardMap.get(hazardValue)?.category ?? null;
};

/**
 * The Biosecurity hazard category. A hazard in this category carries the extra
 * biosecurity taxonomy (report_type / event_type / event_status / domain) — see
 * constants/biosecurityTaxonomy.js. Mirrors Hazard::CATEGORY_BIOSECURITY (PHP).
 */
export const BIOSECURITY_HAZARD_CATEGORY = 'biosecurity_hazards';

export const isBiosecurityHazardCategory = (categoryValue) =>
  categoryValue === BIOSECURITY_HAZARD_CATEGORY;
